import React, { useState, useEffect, useCallback } from 'react';
import { Puzzle8Game, Tile, formatTime } from '../../utils/gameLogic';
import './Puzzle8Game.css';

const Puzzle8GameComponent: React.FC = () => {
  const [game, setGame] = useState(new Puzzle8Game());
  const [tiles, setTiles] = useState<Tile[]>([]);
  const [moves, setMoves] = useState(0);
  const [isWon, setIsWon] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);

  const updateGameState = useCallback(() => {
    setTiles(game.getTiles());
    setMoves(game.getMoves());
    setIsWon(game.getIsWon());
    setTimeElapsed(game.getTimeElapsed());
  }, [game]);

  useEffect(() => {
    updateGameState();

    const timer = setInterval(() => {
      setTimeElapsed(game.getTimeElapsed());
    }, 1000);

    return () => clearInterval(timer);
  }, [game, updateGameState]);

  const handleTileClick = (index: number) => {
    if (game.onTileClick(index)) {
      updateGameState();
    }
  };

  const resetGame = () => {
    setGame(new Puzzle8Game());
  };

  const getDifficultyText = () => {
    if (moves < 20) return "Excellent!";
    if (moves < 40) return "Good!";
    if (moves < 60) return "Not bad!";
    return "Keep trying!";
  };

  return (
    <div className="puzzle-game">
      <div className="game-header">
        <h2>🧩 8-Puzzle Game</h2>
        <p>Move the tiles to arrange them in order from 1 to 8</p>
      </div>
      
      <div className="game-stats">
        <div className="stat-item">
          <span className="stat-label">Moves:</span>
          <span className="stat-value">{moves}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Time:</span>
          <span className="stat-value">{formatTime(timeElapsed)}</span>
        </div>
        {isWon && (
          <div className="stat-item win-message">
            <span className="stat-label">Result:</span>
            <span className="stat-value">{getDifficultyText()}</span>
          </div>
        )}
      </div>
      
      <div className="puzzle-grid">
        {tiles.map((tile, index) => (
          <div
            key={index}
            className={`game-tile ${tile.number === null ? 'empty' : ''} ${isWon ? 'won' : ''}`}
            onClick={() => handleTileClick(index)}
          >
            {tile.number}
          </div>
        ))}
      </div>
      
      <div className="game-controls">
        <button onClick={resetGame} className="reset-button">
          🔄 New Game
        </button>
        {isWon && (
          <button onClick={() => window.location.reload()} className="share-button">
            🎉 Play Again
          </button>
        )}
      </div>
      
      <div className="game-instructions">
        <h4>How to Play:</h4>
        <ul>
          <li>Click on a tile next to the empty space to move it</li>
          <li>Arrange tiles in order from 1 to 8</li>
          <li>Try to solve it in as few moves as possible!</li>
        </ul>
      </div>
    </div>
  );
};

export default Puzzle8GameComponent;
